/* eslint-disable consistent-return */
import React from 'react';
import { useAppState } from '@components/common/context/app';
import './LoadingBar.scss';
var LoadingBar = function LoadingBar() {
  var {
    fetching
  } = useAppState();
  var [width, setWidth] = React.useState(0);
  var widthRef = React.useRef(0);
  React.useEffect(() => {
    widthRef.current = width;
    if (fetching === true) {
      // Random number between 1 and 3
      var step = Math.random() * (3 - 1) + 1;
      // Random number between 85 and 95
      var peak = Math.random() * (95 - 85) + 85;
      if (widthRef.current < peak) {
        var timer = setTimeout(() => setWidth(widthRef.current + step), 0);
        return () => clearTimeout(timer);
      }
    } else if (widthRef.current === 100) {
      setWidth(0);
      widthRef.current = 0;
    } else if (widthRef.current !== 0) {
      setWidth(100);
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "loading-bar",
    style: {
      width: "".concat(width, "%"),
      display: fetching === true ? 'block' : 'none'
    }
  });
};
export default LoadingBar;